import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import HomePage from './components/pages/HomePage';
import ElektrotechnikPage from './components/pages/ElektrotechnikPage';
import EnergietechnikPage from './components/pages/EnergietechnikPage';
import FoerdertechnikPage from './components/pages/FoerdertechnikPage';
import IukPage from './components/pages/IukPage';
import SicherheitstechnikPage from './components/pages/SicherheitstechnikPage';
import ArchitekturPage from './components/pages/ArchitekturPage';
import ReferenzenPage from './components/pages/ReferenzenPage';
import UeberUnsPage from './components/pages/UeberUnsPage';
import BimPage from './components/pages/BimPage';
import DenkmalschutzPage from './components/pages/DenkmalschutzPage';
import StellenangebotePage from './components/pages/StellenangebotePage';
import SoftwarePage from './components/pages/SoftwarePage';
import HlsPage from './components/pages/HlsPage';
import KontaktPage from './components/pages/KontaktPage';
import ImpressumPage from './components/pages/ImpressumPage';
import DatenschutzPage from './components/pages/DatenschutzPage';
import AgbPage from './components/pages/AgbPage';
import NotFoundPage from './components/pages/NotFoundPage';
import './styles/App.css';
// Auth entfernt

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/elektrotechnik" element={<ElektrotechnikPage />} />
          <Route path="/energietechnik" element={<EnergietechnikPage />} />
          <Route path="/foerdertechnik" element={<FoerdertechnikPage />} />
          <Route path="/iuk" element={<IukPage />} />
          <Route path="/sicherheitstechnik" element={<SicherheitstechnikPage />} />
          <Route path="/architektur" element={<ArchitekturPage />} />
          <Route path="/referenzen" element={<ReferenzenPage />} />
          <Route path="/ueber-uns" element={<UeberUnsPage />} />
          <Route path="/bim" element={<BimPage />} />
          <Route path="/denkmalschutz" element={<DenkmalschutzPage />} />
          <Route path="/stellenangebote" element={<StellenangebotePage />} />
          <Route path="/software" element={<SoftwarePage />} />
          <Route path="/hls" element={<HlsPage />} />
          <Route path="/kontakt" element={<KontaktPage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/datenschutz" element={<DatenschutzPage />} />
          <Route path="/agb" element={<AgbPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;